const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in')
        observer.unobserve(entry.target)
      }
    })
  },
  {
    threshold: 0.25,
  }
)

document.addEventListener('DOMContentLoaded', function () {
  const elementsToObserve = document.querySelectorAll(
    '.case-study__video, .case-study__image'
  )
  elementsToObserve.forEach((element) => {
    observer.observe(element)
  })
})
